import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getPowerGenerationHourMeterList as getPowerGenerationHourMeterListApi,
	getPowerGenerationHourMeterQuery as getPowerGenerationHourMeterQueryApi,
	getPowerGenerationHourMeter as getPowerGenerationHourMeterApi,
	addNewPowerGenerationHourMeter as addNewPowerGenerationHourMeterApi,
	updatePowerGenerationHourMeter as updatePowerGenerationHourMeterApi,
	deletePowerGenerationHourMeter as deletePowerGenerationHourMeterApi,
} from '../../helpers/establishment/backend_helper';

export const getPowerGenerationHourMeterList = createAsyncThunk('powerGenerationHourMeter/getPowerGenerationHourMeterList', async (params) => {
	try {
		const response = getPowerGenerationHourMeterListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPowerGenerationHourMeterQuery = createAsyncThunk('powerGenerationHourMeter/getPowerGenerationHourMeterQuery', async (params) => {
	try {
		const response = getPowerGenerationHourMeterQueryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPowerGenerationHourMeter = createAsyncThunk('powerGenerationHourMeter/getPowerGenerationHourMeter', async powerGenerationHourMeter_id => {
	try {
		const response = getPowerGenerationHourMeterApi(powerGenerationHourMeter_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewPowerGenerationHourMeter = createAsyncThunk('powerGenerationHourMeter/addNewPowerGenerationHourMeter', async powerGenerationHourMeter => {
	try {
		const response = await addNewPowerGenerationHourMeterApi(powerGenerationHourMeter);
		toast.success('Registro agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar powerGenerationHourMeter.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updatePowerGenerationHourMeter = createAsyncThunk('powerGenerationHourMeter/updatePowerGenerationHourMeter', async (powerGenerationHourMeter) => {
		try {
			const response = updatePowerGenerationHourMeterApi(powerGenerationHourMeter);
			toast.success('Registro del Horómetro actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar powerGenerationHourMeter.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deletePowerGenerationHourMeter = createAsyncThunk('powerGenerationHourMeter/deletePowerGenerationHourMeter', async powerGenerationHourMeter => {
	try {
		const response = await deletePowerGenerationHourMeterApi(powerGenerationHourMeter);
		toast.success('Registro del Horómetro eliminado exitosamente.', { autoClose: 3000 });
		return { powerGenerationHourMeter, ...response };
	} catch (error) {
		toast.error('Error al eliminar powerGenerationHourMeter.', { autoClose: 3000 });
		throw new Error(error);
	}
});


